<template>
    <div class="footer">
        <div class="inner">
        <!-- 横线分割 -->
        <div class="divider"></div>
        <!-- 联系方式 -->
        <div class="official-logo">
            <!-- logo -->
            <div class="official">
                <img  src="../assets/footer-logo.png"/>
            </div>
            <!-- 联系人 -->
            <div class="footer-text" style="margin-top: 60px;">
                <p>商务合作 ：关女士 18610304778</p>
                <!-- <p>公司事务 ：王女士 13910089689</p> -->
                <p>办公地址 ：北京市丰台区星火科技大厦7层</p>
            </div>
            <!-- 二维码 -->
            <div class="code">
                <img src="/gaeawechat.png" />
            </div>
        </div>
        <!-- 备案  公司 -->
        <div class="footer-2" style="margin-bottom: 2rem;">
            <div class="divider"></div>
            <!-- 备案 -->
            <div style="padding: 20px 0px;
                display: flex;
                align-items: center;
                justify-content: center;">
                <img src="../assets//gongan.png" />
                <p style="font-size: 14px;
                    float: right;
                    height: 20px;
                    line-height: 20px;
                    margin: 0px 0px 0px 5px;
                    color: #fff;"><a href="https://beian.miit.gov.cn/ " target="_blank" style="color: inherit; text-decoration: none;">京ICP备2022028562号</a></p>
            </div>
            <!-- 公司 -->
            <p class=".text"  style="text-align: center; ">©2023 北京云中盖娅科技有限公司</p>
        </div>
    </div>
    </div>
    
</template>

<script>
export default {
    name: 'demo2',
    data() {
        return {
        };
    },
    mounted(){
        
    },
}
</script>

<style>
.footer{
    /* background: url(../assets/footer-bg1.jpg); */
    background-size: cover;
    padding-top: 50px;
    padding-bottom: 0px;
}
.footer .inner{
    padding-bottom: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.footer .footer-1{
    display: -webkit-flex;
    justify-content: space-around;
    margin-bottom: 30px;
    margin-top: 30px;
    width: 700px;
}

.footer .footer-1 a{
    color: #fff;
    font-size: 18px;
    margin-bottom: 25px;
}

.footer .divider{
    border-top: 1px solid #FFFFFF;
    padding-top: 10px;
}

.footer .footer-2 .divider {
    color: #FFFFFF;
    margin-top: 10px;
    width: 720px;
}

.footer .official img{
    width: 80px;
    height: 80px;
    margin: 55px 20px 0px 0px;
}
.footer .code img{
    width: 80px;
    height: 80px;
    margin: 55px 20px 0px 0px;
    margin-left: 30px;
}

.footer .official-logo{
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #ffffff;
    margin-bottom: 40px;
}

.footer .text{
    text-align: center;
    font-size: 14px;
    padding-top: 45px;
    color: #FFFFFF;
}
.footer .footer-text p{
    margin-bottom: 5px;
}
</style>